/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Background from "./atom/Background";
import CircleLogin from "./atom/CircleLogin";
import Color from "./atom/Color";
import Css from "./atom/Css";
import Fonts from "./atom/Fonts";
import FooterHtml from "./atom/FooterHtml";
import HeaderHtml from "./atom/HeaderHtml";
import Logo from "./atom/Logo";
import Promotional from "./atom/Promotional";

function Body({ domainBrand, fontStore }) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary ? dictionary["m_visual_settings"] : "Brand Settings"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <React.Fragment>
              {/* COLOR SETTINGS */}
              <Color dictionary={dictionary} domainBrand={domainBrand} />

              {/* FONT SETTINGS */}
              <Fonts
                dictionary={dictionary}
                fontStore={fontStore}
                domainBrand={domainBrand}
              />

              {/* BACKGROUND SETTINGS */}
              <Background dictionary={dictionary} domainBrand={domainBrand} />

              {/* LOGO UPLOAD */}
              <Logo dictionary={dictionary} domainBrand={domainBrand} />

              {/* PROMOTIONAL */}
              <Promotional dictionary={dictionary} domainBrand={domainBrand} />

              {/* CIRCLE LOGIN */}
              <CircleLogin dictionary={dictionary} />

              {/* CSS CONTENT */}
              <Css dictionary={dictionary} domainBrand={domainBrand} />

              {/* FOOTER HTML */}
              <FooterHtml dictionary={dictionary} domainBrand={domainBrand} />

              {/* HEADER HTML */}
              <HeaderHtml dictionary={dictionary} domainBrand={domainBrand} />
            </React.Fragment>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
